




































import { IStaff } from "@/interfaces";
import { HELPER } from "@/utils/Helper";
import Vue from "vue";
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";

// import axios from "axios";
// import * as CL from "../Mtc_classes";
// import { MtcADMIN } from "../Mtc";
// import AdminTemplate from "../../../dev/Components/AdminTemplate.vue";
// import AdminTitles from "../../../dev/Components/AdminTitles.vue";

@Component({
  components: {},
})
export default class BOILERPLATE_COMPONENT extends Vue {
  constructor() {
    super();
  }

  /* LIFECYCLE METHODS */
  mounted() {
		this.LoadTechs();
  }

  /* PROPS VARIABLES, They have to be lower case, or first capital only, 
		otherwise they will fail ! */
  @Prop()
  public value: number;

  /* PRIVATE VARIABLES, __ POSTFIXED */
  // private myVar__: any;

  /* VUE DATA */
  public Techs: IStaff[] = [];
  public OurValue: number = null;

	@Getter("getTimestampStaff", { namespace: "AppModule" })
  private getTimestampStaff: string;


  /* VUE WATCH */
  @Watch("value")
  onValueChanged(newVal: any, oldVal: any) {
    this.OurValue = newVal;
  }


  @Watch("getTimestampStaff")
  onStaffChange(newVal: any, oldVal: any) {
		/// WE ARE WATCHING A VUEX VARIABLE THAT TELLS 
		/// IF THE USERS CHANGED, IN WHICH CASE WE SHOULD
		/// TRIGGER A NEW SEARCH.
		this.LoadTechs();
	}


  /* PRIVATE METHODS */
	public LoadTechs():void{
    this.Techs = this.$store.getters["AppModule/staff"].sort(
      (a: IStaff, b: IStaff) => {
        return a.Initials.localeCompare(b.Initials);
      }
    ).filter(t=>t.IsActive);
	}

  public ClearTech(): void {
    (this.$refs.techsel as any).focus();

    this.$nextTick(() => {
      (this.$refs.techsel as any).blur();
    });
  }

  public FiltersUpdated(): void {
    this.$emit('input', this.OurValue);
    this.$emit('update');
  }

  /* VUE METHODS */
  // public DoNothing():void{}
}
